export default __webpack_public_path__ + "static/media/ShiftsMaster.b2ab562d.svg";